import { useState, useEffect } from 'react';
import { metadataService, SelectOption } from '../services/metadataService';

interface MetadataState {
  categories: SelectOption[];
  groups: SelectOption[];
  types: SelectOption[];
  tags: SelectOption[];
  sources: SelectOption[];
  isLoading: boolean;
  error: string | null;
}

export function useMetadata() {
  const [state, setState] = useState<MetadataState>({
    categories: [],
    groups: [],
    types: [],
    tags: [],
    sources: [],
    isLoading: true,
    error: null
  });

  useEffect(() => {
    const fetchMetadata = async () => {
      try {
        const [categories, groups, types, tags, sources] = await Promise.all([
          metadataService.getCategories(),
          metadataService.getGroups(),
          metadataService.getTypes(),
          metadataService.getTags(),
          metadataService.getSources()
        ]);

        setState({
          categories,
          groups,
          types,
          tags,
          sources,
          isLoading: false,
          error: null
        });
      } catch (error) {
        setState(prev => ({
          ...prev,
          isLoading: false,
          error: 'Failed to load metadata'
        }));
      }
    };

    fetchMetadata();
  }, []);

  return state;
}
